export default {"src":"/_next/static/media/Balance and Coordination Issues.c4d57c36.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};